<template>
  <div>
    <AlertLayout title="Reminders!" message="<ul>
  <li>You will receive an sms / email notification once the requisition you sent is received and processed by the receiving entity.</li>
  <li>An 'Expired' status means a new blood sample has to be drawn from the patient and a new requisition form manually filled, should you choose the more blood option.</li>
  <li> Click on units amount to 'REQUEST FOR MORE BLOOD' for that particular patient.</li></ul>" type="warning" />
    <div class="flex justify-end mt-5 space-x-2">
      <button v-if="requisition && (!requisition.samples || requisition.samples.length > 0)" type="submit"
        class="px-4 py-2 ml-3 bg-custom-yellow text-white rounded" @click="toggleProductsDropdown">
        View Products
      </button>
      <button
        v-if="requisition && (!requisition.samples || requisition.samples.length === 0 || requisition.samples.some(sample => sample.sample_status === 'rejected')) && flag == 'inventory_management'"
        type="submit" class="px-4 py-2 ml-3 bg-custom-yellow text-white rounded"
        @click="redirectToAddSample(requisition.requisition_id)">
        Add Sample
      </button>
      <div v-if="isPageLoading" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div class="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-yellow-500"></div>
      </div>
    </div>
    <!-- Dropdown table -->
    <div class="bg-white p-8 mt-2 rounded-lg shadow-inner overflow-hidden" v-if="showProductsDropdown">
      <table class="min-w-full divide-y divide-gray-200 border border-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-4 py-2 text-left text-base tracking-wider">
              Product
            </th>
            <th class="px-4 py-2 text-left text-base tracking-wider">
              Unit(s) Requested/Assigned
            </th>
            <th class="px-4 py-2 text-left text-base tracking-wider">
              Volume Requested
            </th>
            <th class="px-4 py-2 text-left text-base tracking-wider">
              Issued
            </th>
            <th class="px-4 py-2 text-left text-base tracking-wider"></th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr v-for="(product, index) in requisition.requisition_products" :key="index">
            <td class="px-4 py-1 whitespace-nowrap text-base">
              {{ product.name || "N/A" }}
            </td>
            <td class="px-4 py-1 whitespace-nowrap text-base">
              {{ parseFloat(product.quantity) % 1 === 0 ? parseInt(product.quantity) : product.quantity }}/{{
                product.assigned_units.length }}
            </td>
            <td class="px-4 py-1 whitespace-nowrap text-base">
              {{ product.volume || "N/A" }}
            </td>
            <td class="px-4 py-1 whitespace-nowrap text-base">
              {{product.assigned_units.filter(unit => unit.status === 'Issued').length}}
            </td>
            <td class="px-4 py-1 whitespace-nowrap text-base">
              <div class="flex justify-end space-x-2">
                <button type="button" class="px-4 py-1 bg-custom-yellow text-white rounded"
                  @click="redirectToAssignUnit((product.requisition_product_id))"
                  v-if="requisition.samples[0].sample_status != 'rejected' &&
                    product.assigned_units.length < product.quantity && requisition.status != 'Cancelled' && flag == 'inventory_management'">
                  Assign Unit
                </button>

                <button type="button" class="px-4 py-1 bg-custom-yellow text-white rounded"
                  @click="handlePrintSticker(product)" v-if="requisition.samples[0].sample_status != 'rejected' &&
                    product.assigned_units.length > 0 && requisition.status != 'Cancelled'">
                  Print Sticker
                </button>

                <button type="button" class="px-4 py-1 bg-custom-yellow text-white rounded"
                  @click="viewIssueOutPopup(product)"
                  v-if="requisition.samples[0].sample_status !== 'rejected' &&
                    product.assigned_units.length > 0 &&
                    product.quantity > product.assigned_units.filter(issued => issued.status === 'Issued').length && requisition.status != 'Cancelled' && flag == 'inventory_management'">
                  Issue Out
                </button>
              </div>

            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- <div v-if="showProductsDropdown"
      class="fixed inset-0 bg-gray-900 bg-opacity-60 overflow-y-hidden h-full w-full flex items-center justify-center text-base">
      <div class="bg-white p-8 rounded-lg shadow-xl w-6/12 overflow-hidden">

      </div>
    </div> -->

    <div class="px-4">
      <h3 class="flex justify-start text-lg mt-5 mb-3">Requisition status: <span
          class="font-semibold dark:text-custom-yellow">{{ requisition?.status ?? '' }}</span></h3>
      <h3 class="text-lg font-semibold mt-5 mb-3">Patient Details</h3>

      <div>
        <div v-if="requisition" class="grid grid-cols-2 gap-4">
          <!-- Left Column -->
          <div class="space-y-6">
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Name</label>
              <p class="text-base font-semibold mt-3">
                {{ requisition.patient.first_name }}
                {{ requisition.patient.last_name }}
              </p>
            </div>

            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Date of birth</label>
              <p class="text-base font-semibold mt-3">
                {{ requisition.patient.dob }}
              </p>
            </div>
          </div>

          <div class="space-y-6">
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Gender</label>
              <p class="text-base font-semibold mt-3">
                {{ requisition.patient.gender }}
              </p>
            </div>
          </div>
        </div>

        <div v-else>Loading requisition details...</div>

        <h3 class="text-lg font-semibold mt-9 mb-3">
          Patient Medical Information
        </h3>

        <div v-if="requisition" class="grid grid-cols-2 gap-4">
          <!-- Left Column -->
          <div class="space-y-6">
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Blood group</label>
              <p class="text-base font-semibold mt-3">
                {{ requisition.patient.blood_group.description }}
              </p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Patient Type</label>
              <p class="text-base font-semibold mt-3">
                {{ requisition.patient.patient_type }}
              </p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">IP/OP No</label>
              <p class="text-base font-semibold mt-3">
                {{ requisition.patient.ipop }}
              </p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Ward</label>
              <p class="text-base font-semibold mt-3">
                {{ requisition.department.name }}
              </p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Bed no</label>
              <p class="text-base font-semibold mt-3">{{ requisition.bed.name }}</p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Patient Situation</label>
              <p class="text-base font-semibold mt-3">
                {{ requisition.patient_situation }}
              </p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Patient Intent</label>
              <p class="text-base font-semibold mt-3">
                {{ requisition.patient_intent }}
              </p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Reason for transfusion</label>
              <p class="text-base font-semibold mt-3">{{ requisition.transfusion_reason }} </p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Patient HB</label>
              <p class="text-base font-semibold mt-3">{{ requisition.patient_hb }}</p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Platelets level</label>
              <p class="text-base font-semibold mt-3">
                {{ requisition.platelets_level }}
              </p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Patient INR</label>
              <p class="text-base font-semibold mt-3">
                {{ requisition.patient_inr }}
              </p>
            </div>
          </div>
          <!-- Right Column -->
          <div class="space-y-6">
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Consultant</label>
              <p class="text-base font-semibold mt-3">{{ requisition.consultant.first_name }} {{
                requisition.consultant.last_name }}</p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Nurse in-charge</label>
              <p class="text-base font-semibold mt-3">{{ requisition.nurse_in_charge.first_name }} {{
                requisition.nurse_in_charge.last_name }}</p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Previous Transfusion Date</label>
              <p class="text-base font-semibold mt-3">
                {{ requisition.previous_transfusion_date }}
              </p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Reaction to Transfusion</label>
              <p class="text-base font-semibold mt-3">{{ requisition.reaction ? 'Yes' : 'No' }}</p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Signed consent form</label>
              <p class="text-base font-semibold mt-3">
                {{ requisition.consent?.signed ? 'Yes' : 'No' }}
              </p>
            </div>

            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Date consent form signed</label>
              <p class="text-base font-semibold mt-3">
                {{ requisition.consent?.date }}
              </p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Sample Collected</label>
              <p class="text-base font-semibold mt-3">
                {{ requisition.pre_transfusion_sample ? 'Yes' : 'No' }}
              </p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Date sample collected</label>
              <p class="text-base font-semibold mt-3">
                {{ requisition.sample_collection_date }}
              </p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Contact Nurse</label>
              <p class="text-base font-semibold mt-3">{{ requisition.contact_nurse.first_name }} {{
                requisition.contact_nurse.last_name }}</p>
            </div>

            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Product(s) for which consent form signed</label>
              <p class="text-base font-semibold mt-3"></p>
            </div>
          </div>
        </div>
        <div v-else>Loading requisition details...</div>

        <h3 class="text-lg font-semibold mt-9 mb-3">Sample Details</h3>

        <div v-if="requisition" class="grid grid-cols-2 gap-4">
          <!-- Left Column -->
          <div class="space-y-6">
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Sample No</label>
              <p class="text-base font-semibold mt-3">{{ requisition.samples.length > 0 ?
                requisition.samples[0].sample_number
                : '' }}</p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Sample Status</label>
              <p class="text-base font-semibold mt-3">{{ requisition.samples.length > 0 ?
                requisition.samples[0].sample_status
                : '' }}</p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Test to be Done</label>
              <p v-if="sampleTests.length" class="text-base font-semibold mt-3">
                <span v-for="(test, index) in sampleTests" :key="index">
                  {{ test }}<span v-if="index < sampleTests.length - 1">, </span>
                </span>
              </p>
              <p v-else class="text-base font-semibold mt-3"></p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Lab No</label>
              <p class="text-base font-semibold mt-3">{{ requisition.samples.length > 0
                ? requisition.samples[0].sample_lab_number : '' }}</p>
            </div>
            <div v-if="requisition.samples.length > 0 && requisition.samples[0].du_test_results"
              class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Du Test Results</label>
              <p class="text-base font-semibold mt-3">{{ requisition.samples.length > 0
                ? requisition.samples[0].du_test_results : '' }}</p>
            </div>
            <div v-if="requisition.samples.length > 0 && requisition.samples[0].direct_coombs_test_results"
              class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Direct Coomb's Test Results</label>
              <p class="text-base font-semibold mt-3">{{ requisition.samples.length > 0
                ? requisition.samples[0].direct_coombs_test_results : '' }}</p>
            </div>
          </div>

          <div class="space-y-6">
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Received by</label>
              <p class="text-base font-semibold mt-3">{{ requisition.samples.length > 0 ?
                requisition.samples[0].sample_received_by : '' }}</p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Rejected Reason</label>
              <p class="text-base font-semibold mt-3">{{ requisition.samples.length > 0 ?
                requisition.samples[0].rejection_reason : '' }}</p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Corrective Action</label>
              <p class="text-base font-semibold mt-3">{{ requisition.samples.length > 0 ?
                requisition.samples[0].corrective_action : '' }}</p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Corrected by</label>
              <p class="text-base font-semibold mt-3">{{ requisition.samples.length > 0 ?
                requisition.samples[0].corrective_action_by : '' }}</p>
            </div>
            <div v-if="requisition.samples.length > 0 && indirectCoombsResult"
              class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Indirect Coomb's Test Results</label>
              <p class="text-base font-semibold mt-3">{{ indirectCoombsResult }}</p>
            </div>
          </div>
        </div>

        <div v-else>Loading requisition details...</div>

        <h3 class="text-lg font-semibold mt-9 mb-3">Requisition Details</h3>

        <div v-if="requisition" class="grid grid-cols-2 gap-4">
          <!-- Left Column -->
          <div class="space-y-6">

            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Blood Unit Assigned</label>
              <div class="text-base font-normal mt-3">
                <div v-for="(product, productIndex) in requisition.requisition_products" :key="productIndex">
                  <template v-for="(unit, unitIndex) in product.assigned_units" :key="unitIndex">
                    <div class="flex items-center space-x-2 mb-1">
                      <span>{{ unit.pint_serial }}</span>
                      <button v-if="unit.transfusion_reaction_id"
                        type="button"
                        class="px-2 py-1 text-xs bg-orange-400 text-white rounded hover:bg-orange-500"
                        @click="openReactionModal(unit)">
                        View Reaction
                      </button>
                    </div>
                  </template>
                </div>
              </div>
            </div>

            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Blood Unit Issued</label>
              <div class="text-base font-normal mt-3">
                <div v-for="(product, index) in requisition.requisition_products" :key="index">
                  <span v-if="product.assigned_units.length > 0">
                    {{product.assigned_units
                      .filter(unit => unit.status === 'Issued')
                      .map(unit => unit.pint_serial)
                      .join(', ')}}
                  </span>
                </div>
              </div>
            </div>

            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Lab Tech</label>
              <p class="text-base font-semibold mt-3">
                {{ requisition.samples ? requisition.samples[0]?.gxm_confirmed_by?.first_name : '' }}
                {{ requisition.samples ? requisition.samples[0]?.gxm_confirmed_by?.last_name : '' }}
              </p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Collector</label>
              <p class="text-base font-semibold mt-3"></p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Time Blood is ready for Collection</label>
              <p class="text-base font-semibold mt-3"></p>
            </div>
          </div>


          <div class="space-y-6">

            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Time Blood Collected</label>
              <p class="text-base font-semibold mt-3"></p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Time Transfusion Commenced</label>
              <p class="text-base font-semibold mt-3"></p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Time Transfusion Ended</label>
              <p class="text-base font-semibold mt-3"></p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Turn Around Time</label>
              <p class="text-base font-semibold mt-3"></p>
            </div>
          </div>
        </div>

        <div v-else>Loading requisition details...</div>


        <div v-if="requisition" class="grid grid-cols-2 gap-4 mt-10">
          <!-- Left Column -->
          <div class="space-y-6">

            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Updated By</label>
              <p class="text-base font-semibold mt-3">{{ requisition.updated_by.first_name }} {{
                requisition.updated_by.last_name }}</p>
            </div>
          </div>

          <div class="space-y-6">
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-base font-normal mt-3">Update Requisition Comments</label>
              <p class="text-base font-semibold mt-3">{{ requisition.comments }}
              </p>
            </div>
          </div>
        </div>

        <div v-else>Loading requisition details...</div>

        <div class="flex justify-end mt-5 space-x-2">
          <button v-if="flag == 'clinical_management'"
            class="px-4 py-2 border rounded text-orange-500 border-orange-500" @click="cancelRequisition">
            Cancel Requisition
          </button>
          <button type="submit" class="px-4 py-2 ml-3 bg-custom-yellow text-white rounded"
            @click="redirectToEditRequisitionForm(requisition.requisition_id)">
            Edit
          </button>
          <button v-if="flag == 'clinical_management'" type="submit"
            class="px-4 py-2 ml-3 bg-custom-yellow text-white rounded" @click="viewDifferentWardPopup">
            Move to Different Ward
          </button>
        </div>
      </div>

      <div v-if="showIssueOutPopup"
        class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center">
        <div class="bg-white p-8 rounded-lg shadow-xl w-1/2 max-w-3xl">
          <div class="flex items-center">
            <h2 class="text-lg font-bold mb-4">Unit Issue Out Confirmation</h2>
            <button type="button"
              class="ml-auto -mx-1.5 -my-1.5 p-1.5 inline-flex text-gray-800 items-center justify-center h-8 w-8"
              @click="closeIssueOutPopup" aria-label="Close">
              <span class="sr-only">Dismiss</span>
              <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 14 14">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
              </svg>
            </button>
          </div>
          <div>
            <div v-for="unit in selectedProduct" :key="unit.assigned_units_id" class="flex items-center mb-5 mt-5">
              <input :id="'checkbox-table-search-' + unit.assigned_units_id" :value="unit.assigned_units_id"
                type="checkbox"
                class="w-4 h-4 text-custom-yellow bg-gray-100 border-gray-300 mr-3 rounded focus:ring-custom-yellow"
                v-model="selectedUnitIds" />
              <label :for="'checkbox-unit-' + unit.assigned_units_id" class="sr-only">checkbox</label>
              <h4 class="text-md font-semibold">Issue out unit {{ unit.pint_serial }}.</h4>
            </div>
            <div v-if="hasPorterNameAar">
              <label class="block mb-2 text-gray-700 font-medium" for="collector">Collectors Name </label>
              <div class="relative">
                <select id="collector"
                  class="w-full p-3 border rounded bg-gray-100 placeholder-gray shadow-sm shadow-gray-400 appearance-none"
                  v-model="selectedIssuedBy" required>
                  <option value="" disabled selected>Select Collector</option>
                  <option v-for="collector in filteredConsultants" :key="collector.user_id" :value="collector.user_id">
                    {{ collector.first_name }} {{ collector.last_name }}
                  </option>
                </select>
                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                  </svg>
                </div>
              </div>
            </div>
            <div v-if="selectedIssuedBy">
              <div class="flex justify-end">
                <button @click="requestOtp" class="px-4 py-2 my-4 bg-gray-500 text-white rounded">Request OTP</button>
              </div>
              <input v-model="otp" type="text" placeholder="Enter OTP" class="mt-3 p-2 border rounded w-full" />
            </div>
            <div v-if="!hasPorterNameAar">
              <label class="block mb-1" for="collector">Type Collector's name</label>
              <input id="collector" type="text"
                class="w-full p-3 border rounded bg-gray-100 placeholder-gray shadow-sm shadow-gray-400 appearance-none"
                placeholder="Enter Name" v-model="issued_to_name" />
            </div>

            <div class="flex justify-end mt-5 space-x-2">
              <button type="button" @click="closeIssueOutPopup"
                class="px-4 py-2 bg-gray-200 text-gray-800 rounded">Cancel</button>
              <button type="submit" class="px-4 py-2 ml-3 bg-custom-yellow text-white rounded"
                @click="issueOut">Submit</button>
            </div>
          </div>
        </div>
      </div>

<div v-if="showDifferentWardPopup"
        class="fixed inset-0 bg-gray-900 bg-opacity-75 flex justify-center items-center z-50 backdrop-blur-sm">
      <div class="bg-white p-8 rounded-lg shadow-xl w-6/12">
        <div>
          <label class="block mb-4 text-gray-700 font-medium" for="blood_group">Move Patient to a Different Ward
            <span class="text-red-500">*</span></label>
          <div class="relative">
            <select id="blood_group_id" v-model="formData.department_id"
              class="w-full p-3 border rounded bg-gray-100 placeholder-gray shadow-sm shadow-gray-400 appearance-none"
              required>
              <option value="" disabled selected>Select Ward</option>
              <option v-for="ward in departments" :key="ward.department_id" :value="ward.department_id">
                {{ ward.name }}
              </option>
            </select>
            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
              <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
              </svg>
            </div>
          </div>
          <div class="flex justify-end mt-6 space-x-2">
            <button type="button" @click="closeDifferentWardPopup"
              class="px-4 py-2 bg-gray-200 text-gray-800 rounded">
              Cancel
            </button>
            <CustomButton @click="moveDepartment" label="Submit" bg-class="bg-custom-yellow" />
          </div>
        </div>
      </div>
    </div>

    <!-- Reaction Modal -->
    <div v-if="showReactionModal"
      class="fixed inset-0 bg-gray-800 bg-opacity-60 overflow-y-auto h-full w-full flex items-center justify-center">
      <div class="bg-white p-8 rounded-lg shadow-xl w-full max-w-7xl mx-4 max-h-[92vh] flex flex-col">
        <div class="flex justify-between items-center mb-4">
          <h2 class="text-2xl text-gray-800 font-bold">Reaction Flow Sheet</h2>
          <button type="button" @click="closeReactionModal"
            class="text-gray-500 hover:text-gray-700 text-2xl leading-none">&times;</button>
        </div>
        <hr class="h-px my-4 bg-orange-200 border-0 dark:bg-orange-200">

        <!-- TWO COLUMN GRID -->
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 overflow-y-auto flex-1 pr-2">

          <!-- LEFT: REACTION FORM -->
          <section>
            <div class="mb-6">
              <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-3 py-3  border-gray-300">
                <!-- Haemolytic (0-15 mins) -->
                <div>
                  <h3 class="font-bold">HAEMOLYTIC (0-15 MINS)</h3>
                  <div class="flex items-center justify-between px-2 py-2 mt-3">
                    <label class="text-md">Increased BP</label>
                    <input type="checkbox" disabled class="ml-2 p-4 w-4 h-4"
                      :checked="reactionFormData.haemolytic?.increased_bp" />
                  </div>
                  <div class="flex items-center justify-between px-2 py-2">
                    <label class="text-md">Increased Pulse</label>
                    <input type="checkbox" disabled class="ml-2 p-4 w-4 h-4"
                      :checked="reactionFormData.haemolytic?.increased_pulse" />
                  </div>
                  <div class="flex items-center justify-between px-2 py-2">
                    <label class="text-md">Increased Respiratory Rate</label>
                    <input type="checkbox" disabled class="ml-2 p-4 w-4 h-4"
                      :checked="reactionFormData.haemolytic?.increased_respr" />
                  </div>
                  <div class="flex items-center justify-between px-2 py-2">
                    <label class="text-md">Shivering</label>
                    <input type="checkbox" disabled class="ml-2 p-4 w-4 h-4"
                      :checked="reactionFormData.haemolytic?.shivering" />
                  </div>
                  <div class="flex items-center justify-between px-2 py-2">
                    <label class="text-md">Headache</label>
                    <input type="checkbox" disabled class="ml-2 p-4 w-4 h-4"
                      :checked="reactionFormData.haemolytic?.headache" />
                  </div>
                  <div class="flex items-center justify-between px-2 py-2">
                    <label class="text-md">Lower back pain</label>
                    <input type="checkbox" disabled class="ml-2 p-4 w-4 h-4"
                      :checked="reactionFormData.haemolytic?.lower_back_pain" />
                  </div>
                </div>

                <!-- Febrile (30 mins) -->
                <div>
                  <h3 class="font-bold">FEBRILE (30 MINS)</h3>
                  <div class="flex items-center justify-between px-2 py-2 mt-3">
                    <label class="text-md">Increased Temperature</label>
                    <input type="checkbox" disabled class="ml-2 p-4 w-4 h-4"
                      :checked="reactionFormData.febrile?.increased_temperature" />
                  </div>

                  <div class="flex items-center justify-between px-2 py-2">
                    <label class="text-md">Back Pain</label>
                    <input type="checkbox" disabled class="ml-2 p-4 w-4 h-4"
                      :checked="reactionFormData.febrile?.back_pain" />
                  </div>
                  <div class="flex items-center justify-between px-2 py-2">
                    <label class="text-md">Shivering</label>
                    <input type="checkbox" disabled class="ml-2 p-4 w-4 h-4"
                      :checked="reactionFormData.febrile?.shivering" />
                  </div>
                  <div class="flex items-center justify-between px-2 py-2">
                    <label class="text-md">Headache</label>
                    <input type="checkbox" disabled class="ml-2 p-4 w-4 h-4"
                      :checked="reactionFormData.febrile?.headache" />
                  </div>
                  <div class="flex items-center justify-between px-2 py-2">
                    <label class="text-md">Hematemesis</label>
                    <input type="checkbox" disabled class="ml-2 p-4 w-4 h-4"
                      :checked="reactionFormData.febrile?.hematemesis" />
                  </div>
                </div>

                <!-- Allergic -->
                <div>
                  <h3 class="font-bold">ALLERGIC</h3>
                  <div class="flex items-center justify-between px-2 py-2 mt-3">
                    <label class="text-md">Wheezing</label>
                    <input type="checkbox" disabled class="ml-2 p-4 w-4 h-4"
                      :checked="reactionFormData.allergic?.wheezing" />
                  </div>
                  <div class="flex items-center justify-between px-2 py-2">
                    <label class="text-md">Itching</label>
                    <input type="checkbox" disabled class="ml-2 p-4 w-4 h-4"
                      :checked="reactionFormData.allergic?.itching" />
                  </div>
                  <div class="flex items-center justify-between px-2 py-2">
                    <label class="text-md">Hives</label>
                    <input type="checkbox" disabled class="ml-2 p-4 w-4 h-4"
                      :checked="reactionFormData.allergic?.hives" />
                  </div>
                  <div class="flex items-center justify-between px-2 py-2">
                    <label class="text-md">Joint pain</label>
                    <input type="checkbox" disabled class="ml-2 p-4 w-4 h-4"
                      :checked="reactionFormData.allergic?.joint_pain" />
                  </div>
                </div>
              </div>

              <div class="px-2">
                <h3 class="font-bold">Others</h3>
                <div v-if="reactionFormData.others?.length">
                  <h4 class="font-semibold mb-2 text-gray-600">Added Reactions:</h4>
                  <ul class="list-disc text-gray-600 pl-5">
                    <li v-for="(reaction, index) in reactionFormData.others" :key="index" class="border-b py-1 italic">
                      <span>{{ reaction }}</span>
                    </li>
                  </ul>
                </div>
                <div v-else class="text-gray-500 italic">No other reactions recorded</div>
              </div>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-5 mt-4 border-b px-2">
                <label class="block mb-2 text-gray-700 font-medium" for="administeredMedication">Administered
                  medication?</label>
                <div class="flex items-center space-x-4">
                  <label class="inline-flex items-center">
                    <input id="administeredMedicationYes" type="radio" class="form-radio text-blue-500" disabled
                      :checked="reactionFormData.administeredMedication === true" />
                    <span class="ml-2">Yes</span>
                  </label>
                  <label class="inline-flex items-center">
                    <input id="administeredMedicationNo" type="radio" class="form-radio text-blue-500" disabled
                      :checked="reactionFormData.administeredMedication === false" />
                    <span class="ml-2">No</span>
                  </label>
                </div>
              </div>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-5 border-b px-2 py-2">
                <label class="block mb-2 text-gray-700 font-medium" for="reactionTime">Time the reaction
                  happened</label>
                <div class="flex items-center space-x-4">
                  <input :value="reactionFormData.reaction_time" type="datetime-local" disabled
                    class="w-full p-3 border rounded placeholder-gray shadow-sm shadow-gray-400 appearance-none" />
                </div>
              </div>

              <div class="grid grid-cols-1 md:grid-cols-1 gap-5 mt-4 border-b px-2">
                <label class="block font-bold" for="comment">Comment</label>
                <textarea :value="reactionFormData.comment" disabled
                  class="w-full border rounded placeholder-gray-400 p-2 shadow-sm shadow-gray-300"
                  placeholder="Enter comment"></textarea>
              </div>
            </div>
          </section>

          <!-- RIGHT: LAB INVESTIGATION -->
          <section class="lg:border-l lg:pl-8 border-gray-200">
            <h2 class="text-xl text-gray-800 font-bold">
              Lab Investigation
              <span class="text-sm font-normal text-gray-500">(Transfusion manager)</span>
            </h2>

            <!-- 1. Recipient supernatant -->
            <div class="mt-4 border-b pb-3">
              <h3 class="font-semibold">1. Recipient's blood supernatant – Haemolysis</h3>
              <div class="flex flex-wrap gap-4 mt-2">
                <label v-for="opt in ['Present','Absent','Equivocal']" :key="opt" class="inline-flex items-center">
                  <input type="radio" class="form-radio" :value="opt" v-model="reactionFormData.lab.recipient_haemolysis" />
                  <span class="ml-2">{{ opt }}</span>
                </label>
              </div>
              <div v-if="reactionFormData.lab.recipient_haemolysis === 'Present'" class="flex flex-wrap items-center gap-4 mt-2">
                <span class="italic text-gray-600">If present:</span>
                <label v-for="opt in ['Mild','Moderate','Marked']" :key="opt" class="inline-flex items-center">
                  <input type="radio" class="form-radio" :value="opt" v-model="reactionFormData.lab.haemolysis_severity" />
                  <span class="ml-2">{{ opt }}</span>
                </label>
              </div>
            </div>

            <!-- 2. Agglutination -->
            <div class="mt-3 border-b pb-3">
              <h3 class="font-semibold">2. Recipient's blood – Agglutination</h3>
              <div class="flex gap-4 mt-2">
                <label v-for="opt in ['Present','Absent']" :key="opt" class="inline-flex items-center">
                  <input type="radio" class="form-radio" :value="opt" v-model="reactionFormData.lab.agglutination" />
                  <span class="ml-2">{{ opt }}</span>
                </label>
              </div>
            </div>

            <!-- 3. Haematological results -->
            <div class="mt-3 border-b pb-3">
              <h3 class="font-semibold">3. Haematological results</h3>
              <div class="grid grid-cols-2 sm:grid-cols-4 gap-3 mt-2">
                <div v-for="f in haemFields" :key="f.key">
                  <label class="block text-sm text-gray-600">{{ f.label }}</label>
                  <input type="text" v-model="reactionFormData.lab.haematology[f.key]"
                    class="w-full p-2 border rounded shadow-sm" />
                </div>
              </div>
              <div class="grid grid-cols-1 gap-3 mt-3">
                <div v-for="f in filmFields" :key="f.key">
                  <label class="block text-sm text-gray-600">{{ f.label }}</label>
                  <input type="text" v-model="reactionFormData.lab.film[f.key]"
                    class="w-full p-2 border rounded shadow-sm" />
                </div>
              </div>
            </div>

            <!-- 4-5. Donor blood -->
            <div class="mt-3 border-b pb-3">
              <h3 class="font-semibold">4. Donor blood supernatant – Haemolysis</h3>
              <div class="flex gap-4 mt-2">
                <label v-for="opt in ['Present','Absent']" :key="opt" class="inline-flex items-center">
                  <input type="radio" class="form-radio" :value="opt" v-model="reactionFormData.lab.donor_haemolysis" />
                  <span class="ml-2">{{ opt }}</span>
                </label>
              </div>
              <label class="block font-semibold mt-3">5. Age of donor pack</label>
              <input type="text" v-model="reactionFormData.lab.donor_pack_age"
                class="w-full p-2 border rounded shadow-sm" />
            </div>

            <!-- 6-7. Cultures -->
            <div class="mt-3 border-b pb-3">
              <label class="block font-semibold">6. Culture donor pack – Results</label>
              <textarea v-model="reactionFormData.lab.culture_donor" rows="2"
                class="w-full p-2 border rounded shadow-sm"></textarea>
              <label class="block font-semibold mt-3">7. Culture recipient blood – Results</label>
              <textarea v-model="reactionFormData.lab.culture_recipient" rows="2"
                class="w-full p-2 border rounded shadow-sm"></textarea>
            </div>

            <!-- 8. Compatibility -->
            <div class="mt-3 border-b pb-3">
              <h3 class="font-semibold">8. Compatibility testing – recipient serum (pre-transfusion sample) and donor cells (pack)</h3>
              <table class="w-full mt-2 text-left">
                <thead>
                  <tr class="text-sm text-gray-600">
                    <th></th><th class="text-center">Compatible</th><th class="text-center">Incompatible</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="t in compatibilityTests" :key="t.key" class="border-t">
                    <td class="py-2">{{ t.label }}</td>
                    <td class="text-center">
                      <input type="radio" :name="'compat_view_' + t.key" value="Compatible"
                        v-model="reactionFormData.lab.compatibility[t.key]" />
                    </td>
                    <td class="text-center">
                      <input type="radio" :name="'compat_view_' + t.key" value="Incompatible"
                        v-model="reactionFormData.lab.compatibility[t.key]" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- 9. Enzyme treated cells -->
            <div class="mt-3 border-b pb-3">
              <label class="block font-semibold">9. If negative (inconclusive results in 8), set up compatibility with enzyme treated cells – Result</label>
              <textarea v-model="reactionFormData.lab.enzyme_result" rows="2"
                class="w-full p-2 border rounded shadow-sm"></textarea>
            </div>

            <!-- 10. Group O transfused to A/B/AB -->
            <div class="mt-3 border-b pb-3">
              <h3 class="font-semibold">10. Group O transfused to A, B or AB individual – establish from the donor unit</h3>
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-2">
                <div>
                  <label class="block text-sm text-gray-600">Anti A titres</label>
                  <input type="text" v-model="reactionFormData.lab.anti_a_titre"
                    class="w-full p-2 border rounded shadow-sm" />
                </div>
                <div>
                  <label class="block text-sm text-gray-600">Anti B titres</label>
                  <input type="text" v-model="reactionFormData.lab.anti_b_titre"
                    class="w-full p-2 border rounded shadow-sm" />
                </div>
              </div>
            </div>

            <!-- 11. Urinalysis -->
            <div class="mt-3 border-b pb-3">
              <label class="block font-semibold">11. Urinalysis</label>
              <textarea v-model="reactionFormData.lab.urinalysis" rows="2"
                class="w-full p-2 border rounded shadow-sm"></textarea>
            </div>

            <!-- 12. Evaluation -->
            <div class="mt-3 border-b pb-3">
              <label class="block font-semibold">12. Evaluation – Diagnosis</label>
              <textarea v-model="reactionFormData.lab.diagnosis" rows="3"
                class="w-full p-2 border rounded shadow-sm"></textarea>
            </div>

            <!-- 13. Related to transfusion -->
            <div class="mt-3 pb-3">
              <h3 class="font-semibold">Was the adverse reaction related to transfusion?</h3>
              <div class="flex flex-wrap gap-4 mt-2">
                <label v-for="opt in ['Yes','No','Inconclusive']" :key="opt" class="inline-flex items-center">
                  <input type="radio" class="form-radio" :value="opt" v-model="reactionFormData.lab.related_to_transfusion" />
                  <span class="ml-2">{{ opt }}</span>
                </label>
              </div>
              <label class="block font-semibold mt-3">Laboratory Technologist</label>
              <input type="text" v-model="reactionFormData.lab.technologist"
                class="w-full p-2 border rounded shadow-sm" />
            </div>
          </section>
        </div>

        <!-- FOOTER -->
        <div class="flex justify-end space-x-2 pt-4 border-t mt-4">
          <button type="button" @click="closeReactionModal"
            class="px-4 py-2 bg-gray-200 text-gray-800 rounded">Close</button>
          <button type="button" @click="saveLabInvestigation"
            :disabled="isSavingLabInvestigation || !selectedAssignedUnit?.transfusion_reaction_id"
            class="px-4 py-2 bg-custom-yellow text-white rounded disabled:opacity-50">
            {{ isSavingLabInvestigation ? 'Saving...' : 'Save Lab Investigation' }}
          </button>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import CustomButton from "@/components/CustomButton.vue";
import AlertLayout from "@/components/AlertLayout.vue";
import api from "@/services/api";
import SweetAlertService from "@/services/SweetAlertService";
// import hospitalLogo from '@/assets/images/Jiji-Health-Blue-Logo.png';

export default {
  name: "FacilityRequisitionDetailsPage",
  components: {
    CustomButton,
    AlertLayout,
  },
  data() {
    return {
      showProductsDropdown: false,
      showDifferentWardPopup: false,
      showIssueOutPopup: false,
      showReactionModal: false,
      isSavingLabInvestigation: false,
      requisition: null,
      flag: null,
      flags: [],
      hasPorterNameAar: false,
      error: null,
      selectedUnitIds: [],
      assignedUnits: [],
      selectedIssuedBy: "",
      issued_to_name: "",
      selectedProduct: null,
      isPageLoading: false,
      formData: {
        department_id: "",
      },
      reactionFormData: {
        haemolytic: {},
        febrile: {},
        allergic: {},
        others: [],
        administeredMedication: false,
        comment: '',
        reaction_time: '',
        lab: {
          recipient_haemolysis: null,
          haemolysis_severity: null,
          agglutination: null,
          haematology: { wbc: '', hb: '', rbc: '', hct: '', mcv: '', mch: '', mchc: '', plt: '' },
          film: { rbc: '', wbc: '', plt: '' },
          donor_haemolysis: null,
          donor_pack_age: '',
          culture_donor: '',
          culture_recipient: '',
          compatibility: { saline_rt: null, saline_37: null, ahg: null, albumin_37: null },
          enzyme_result: '',
          anti_a_titre: '',
          anti_b_titre: '',
          urinalysis: '',
          diagnosis: '',
          related_to_transfusion: null,
          technologist: '',
        }
      },
      selectedAssignedUnit: null,
      otp: "",
      facility_code: this.userData?.user_roles[0]?.facility_department?.facility?.facility_code || ''
    };
  },
  computed: {
    haemFields() {
      return [
        { key: 'wbc', label: 'WBC' }, { key: 'hb', label: 'HB' },
        { key: 'rbc', label: 'RBC' }, { key: 'hct', label: 'HCT' },
        { key: 'mcv', label: 'MCV' }, { key: 'mch', label: 'MCH' },
        { key: 'mchc', label: 'MCHC' }, { key: 'plt', label: 'PLT' },
      ];
    },
    filmFields() {
      return [
        { key: 'rbc', label: 'Film RBC' }, { key: 'wbc', label: 'WBC' }, { key: 'plt', label: 'PLT' },
      ];
    },
    compatibilityTests() {
      return [
        { key: 'saline_rt', label: 'Saline RT' },
        { key: 'saline_37', label: 'Saline 37' },
        { key: 'ahg', label: 'AHG' },
        { key: 'albumin_37', label: 'Albumin 37' },
      ];
    },
    filteredConsultants() {
      // Check if facility_code is 'AAR001'
      if (this.facility_code === 'AAR001') {
        return this.users;
      }
      return this.users.filter(user => {
        return user.user_roles.some(role => 
          role.role.name === 'Consultant' || role.role.name === 'Nurse'
        );
      });
    },
    sampleTests() {
      if (!this.requisition?.samples?.length) return [];
      const raw = this.requisition.samples[0].test_to_be_done;
      if (!raw) return [];
      // May be a JSON string or already an array
      try {
        return typeof raw === 'string' ? JSON.parse(raw) : raw;
      } catch {
        return [];
      }
    },
    indirectCoombsResult() {
      if (!this.requisition?.samples?.length) return '';
      const raw = this.requisition.samples[0].indirect_coombs_test_results;
      if (!raw) return '';
      try {
        return typeof raw === 'string' ? JSON.parse(raw) : raw;
      } catch {
        return raw;
      }
    },
  },

  props: {
    requisition_id: {
      type: String,
      required: true,
    },
  },

  mounted() {
    this.flag = this.$route.query.flag;
    this.flags = this.$store.getters["auth/flags"];
    this.hasPorterNameAar = this.flags.some(flag => flag === "Porter Name Aar");
    this.userData = this.$store.getters["auth/user"];
    this.facility_logo = this.userData.user_roles[0]?.facility_department?.facility?.logo;

  },

  created() {
    this.getWards();
    this.getRequisitions();
    this.getAssignedUnits();
    this.getUsers()
  },

  methods: {
    user() {
      return this.$store.getters["auth/user"];
    },

    viewIssueOutPopup(product) {
      this.selectedProduct = product.assigned_units.filter(unit => unit.status === "Assigned");
      this.selectedUnitIds = [];
      this.showIssueOutPopup = true;
    },

    closeIssueOutPopup() {
      this.showIssueOutPopup = false;
    },
    viewDifferentWardPopup() {
      this.showDifferentWardPopup = true;
    },

    closeDifferentWardPopup() {
      this.showDifferentWardPopup = false;
    },

    async openReactionModal(assignedUnit) {
      this.selectedAssignedUnit = assignedUnit;
      await this.fetchReactionDetails(assignedUnit.transfusion_reaction_id);
      await this.fetchLabInvestigation(assignedUnit.transfusion_reaction_id);
      this.showReactionModal = true;
    },

    async fetchLabInvestigation(reactionId) {
      if (!reactionId) return;

      try {
        const response = await api.getLabInvestigation(reactionId);
        const results = response.data?.results || response.results || {};
        this.reactionFormData.lab = {
          ...this.reactionFormData.lab,
          ...results,
          haematology: { ...this.reactionFormData.lab.haematology, ...results.haematology },
          film: { ...this.reactionFormData.lab.film, ...results.film },
          compatibility: { ...this.reactionFormData.lab.compatibility, ...results.compatibility },
        };
      } catch (error) {
        console.error('Error fetching lab investigation:', error);
        SweetAlertService.showError('Error', 'Could not load the lab investigation.');
      }
    },

    async saveLabInvestigation() {
      const reactionId = this.selectedAssignedUnit?.transfusion_reaction_id;
      if (!reactionId) return;

      this.isSavingLabInvestigation = true;
      try {
        await api.saveLabInvestigation(reactionId, this.reactionFormData.lab);
        SweetAlertService.showSuccess('Success!', 'Lab investigation saved successfully.');
      } catch (error) {
        console.error('Error saving lab investigation:', error);
        SweetAlertService.showError('Error', error.message || 'Could not save the lab investigation.');
      } finally {
        this.isSavingLabInvestigation = false;
      }
    },

    closeReactionModal() {
      this.showReactionModal = false;
      this.selectedAssignedUnit = null;
      this.reactionFormData = {
        haemolytic: {},
        febrile: {},
        allergic: {},
        others: [],
        administeredMedication: false,
        comment: '',
        reaction_time: '',
        lab: {
          recipient_haemolysis: null,
          haemolysis_severity: null,
          agglutination: null,
          haematology: { wbc: '', hb: '', rbc: '', hct: '', mcv: '', mch: '', mchc: '', plt: '' },
          film: { rbc: '', wbc: '', plt: '' },
          donor_haemolysis: null,
          donor_pack_age: '',
          culture_donor: '',
          culture_recipient: '',
          compatibility: { saline_rt: null, saline_37: null, ahg: null, albumin_37: null },
          enzyme_result: '',
          anti_a_titre: '',
          anti_b_titre: '',
          urinalysis: '',
          diagnosis: '',
          related_to_transfusion: null,
          technologist: '',
        }
      };
    },

    async fetchReactionDetails(reactionId) {
      if (!reactionId) return;
      
      try {
        // First, check if the selected assigned_unit already has the reaction data nested
        if (this.selectedAssignedUnit && this.selectedAssignedUnit.transfusion_reaction) {
          const reaction = this.selectedAssignedUnit.transfusion_reaction;
          const formattedReactionTime = reaction.reaction_time
            ? new Date(reaction.reaction_time).toISOString().slice(0, 16)
            : "";

          this.reactionFormData = {
            haemolytic: reaction.haemolytic || {},
            febrile: reaction.febrile || {},
            allergic: reaction.allergic || {},
            others: reaction.others || [],
            administeredMedication: reaction.administered_medication,
            comment: reaction.comment,
            reaction_time: formattedReactionTime,
            lab: reaction.lab || {
              recipient_haemolysis: null,
              haemolysis_severity: null,
              agglutination: null,
              haematology: { wbc: '', hb: '', rbc: '', hct: '', mcv: '', mch: '', mchc: '', plt: '' },
              film: { rbc: '', wbc: '', plt: '' },
              donor_haemolysis: null,
              donor_pack_age: '',
              culture_donor: '',
              culture_recipient: '',
              compatibility: { saline_rt: null, saline_37: null, ahg: null, albumin_37: null },
              enzyme_result: '',
              anti_a_titre: '',
              anti_b_titre: '',
              urinalysis: '',
              diagnosis: '',
              related_to_transfusion: null,
              technologist: '',
            }
          };
          return;
        }

        // Use the new endpoint to fetch reaction by its ID
        const response = await api.getTransfusionReaction(reactionId);
        const reaction = response.data || response;
        
        if (reaction) {
          const formattedReactionTime = reaction.reaction_time
            ? new Date(reaction.reaction_time).toISOString().slice(0, 16)
            : "";

          this.reactionFormData = {
            haemolytic: reaction.haemolytic || {},
            febrile: reaction.febrile || {},
            allergic: reaction.allergic || {},
            others: reaction.others || [],
            administeredMedication: reaction.administered_medication,
            comment: reaction.comment,
            reaction_time: formattedReactionTime,
            lab: reaction.lab || {
              recipient_haemolysis: null,
              haemolysis_severity: null,
              agglutination: null,
              haematology: { wbc: '', hb: '', rbc: '', hct: '', mcv: '', mch: '', mchc: '', plt: '' },
              film: { rbc: '', wbc: '', plt: '' },
              donor_haemolysis: null,
              donor_pack_age: '',
              culture_donor: '',
              culture_recipient: '',
              compatibility: { saline_rt: null, saline_37: null, ahg: null, albumin_37: null },
              enzyme_result: '',
              anti_a_titre: '',
              anti_b_titre: '',
              urinalysis: '',
              diagnosis: '',
              related_to_transfusion: null,
              technologist: '',
            }
          };
        }
      } catch (error) {
        console.error('Error fetching reaction details:', error);
      }
    },

    async getRequisitions() {
      try {
        const id = this.$route.params.requisition_id;
        console.log("Fetching details for requisition ID:", id);
        const response = await api.getRequisition(id);
        this.requisition = (response.data || response)[0];

        this.getRequisitionProducts(this.requisition.requisition_products);
      } catch (error) {
        this.error = error.message || "Failed to fetch requisition details";
      }
    },

    async getRequisitionProducts(requisitionProducts) {
      try {
        if (requisitionProducts && requisitionProducts.length > 0) {
          const requisitionProductId = requisitionProducts[0].requisition_product_id;

          const response = await api.fetchRequisitionProduct(requisitionProductId);
          this.requisitionProducts = response.data || [];
        } else {
          console.log("No requisition products found for this requisition.");
        }
      } catch (error) {
        this.error = error.message || "Failed to fetch requisition products";
      }
    },

    async cancelRequisition() {
      try {
        const id = this.$route.params.requisition_id;
        const payload = { status: "Cancelled" };

        await api.cancelRequisition(id, payload);

        console.log("API call successful, showing success message.");
        await SweetAlertService.showSuccess(
          "Success!",
          "Requisition cancelled successfully!"
        );

        this.$router.push({ name: "RequisitionManagementPage" });
      } catch (error) {
        console.error("Error cancelling requisition:", error);
        this.error = error.message || "Failed to update requisition status";
      }
    },

    async moveDepartment() {
      try {
        const id = this.$route.params.requisition_id;
        const payload = {
          department_id: this.formData.department_id
        };

        await api.movePatientDepartment(id, payload);
        await SweetAlertService.showSuccess(
          "Success!",
          "Successfully Moved Patient to another ward!"
        );

        this.$router.push({ name: "RequisitionManagementPage" });
      } catch (error) {
        console.error("Error cancelling requisition:", error);
        this.error = error.message || "Failed to update requisition status";
      }
    },

    redirectToAssignUnit(id) {
      this.$router.push({
        name: "AssignUnitPage",
        params: { requisition_product_id: id },
      });

    },

    redirectToEditRequisitionForm(id) {
      this.$router.push({
        name: "NewRequisitionForm",
        params: { requisition_id: id },
      });
    },



    async getAssignedUnits() {
      try {
        const id = this.$route.params.requisition_id;
        console.log("Fetching details for requisition ID:", id);
        const response = await api.getRequisition(id);
        this.requisition = (response.data || response)[0];

        // Extract assigned units from requisition_products
        this.assignedUnits = this.requisition.requisition_products
          .flatMap((product) => product.assigned_units) // Flatten the array of assigned units
          .filter((unit) => unit.status == "Assigned"); // Only keep units that are not assigned (if applicable)
      } catch (error) {
        this.error = error.message || "Failed to fetch requisition details";
      }
    },

    async requestOtp() {
      if (!this.selectedIssuedBy) {
        alert("Please select a consultant first.");
        return;
      }

      try {
        const response = await api.sendOtp(this.selectedIssuedBy);

        alert(response.message);
      } catch (error) {
        console.error("Error requesting OTP:", error);
        alert("Failed to send OTP. Try again.");
      }
    },

    async issueOut() {
      try {
        if (!this.selectedUnitIds || this.selectedUnitIds.length === 0) {
          throw new Error("No units selected");
        }

        if (this.selectedIssuedBy && this.issued_to_name) {
          throw new Error("Please select either a collector's name or type a name, but not both.");
        }

        if (!this.otp && this.hasPorterNameAar) {
          alert("Please enter OTP to proceed.");
          return;
        }

        // 🔹 Verify OTP before proceeding
        if(this.hasPorterNameAar){
          const verifyResponse = await api.verifyOtp(this.selectedIssuedBy, this.otp);
          if (!verifyResponse.message) {
            alert("Invalid OTP. Please try again.");
            return;
          }
        }

        // 🔹 If OTP is valid, proceed with issuing out
        const payload = {
          assigned_units: this.selectedUnitIds.map((unitId) => ({
            assigned_units_id: unitId,
          })),
          requisition_id: this.requisition_id,
          assigned_by: this.user().user_id,
          issued_by: this.selectedIssuedBy,
          issued_to_name: this.issued_to_name,
          issued_on: "",
          status: "Issued",
          otp: this.otp,
        };

        const response = await api.issueOut(payload);
        console.log("Unit issued out successfully:", response);
        await SweetAlertService.showSuccess("Success!", "Unit issued out successfully!");
        window.location.reload();
      } catch (error) {
        this.error = error.message || "Failed to issue out unit";
        console.error("Error issuing out unit:", error.message);
        SweetAlertService.showError("Error", "Error issuing out unit.");
      }
    },

    toggleProductsDropdown() {
      this.showProductsDropdown = !this.showProductsDropdown;
    },

    async getWards() {
      try {
        const response = await api.getDepartments();
        this.departments = (response.data || response).filter(
          (ward) => ward.department_type === "Clinical Area"
        );
      } catch (error) {
        this.error = error.message || "Failed to fetch departments";
      }
    },

    async getUsers() {
      try {
        const response = await api.getUsers();
        this.users = response.filter(user => Array.isArray(user.user_roles) && user.user_roles.length > 0);
      } catch (error) {
        this.error = error.message || "Failed to fetch users";
      }
    },

    async redirectToAddSample(requisition) {
      this.isPageLoading = true;
      try {
        await new Promise(resolve => setTimeout(resolve, 500));
        this.$router.push({
          name: "AddSampleForm",
          params: { requisition_id: requisition }, // Pass the entire requisition object
        });
      } catch {
        this.isPageLoading = false;
      }
    },

    async handlePrintSticker(product) {
      const printWindow = document.createElement('iframe');
      printWindow.style.position = 'absolute';
      printWindow.style.width = '0';
      printWindow.style.height = '0';
      document.body.appendChild(printWindow);

      try {
        const patient = this.requisition.patient;
        const department = this.requisition.department.name;
        const consultant = this.requisition.consultant;
        const sample = this.requisition.samples[0];
        const isAarCompatibilitySticker = this.flags.some(flag => flag === "Aar Compatibility sticker");


        let allPrintContent = '';
        product.assigned_units.forEach(unit => {
          const productDetails = {
            name: unit.unit_product.name || "N/A",
            volume: unit.volume || "N/A",
            bloodGroup: unit.blood_group.description || "N/A",
            serialNumber: unit.pint_serial || "N/A",
            expiryDate: unit.expiry_date || "N/A"
          };

          const notInAar = !isAarCompatibilitySticker ? `
          <p><span class="label">Sample No:</span> <span class="value">${sample.sample_number}</span></p>
          `: '';
          const isInAar = isAarCompatibilitySticker ? `
          <p><span class="label">Compatible:</span> 
                <span class="value">${sample.gxm_confirmed_by?.first_name || sample.gxm_confirmed_by?.last_name ? 'Yes' : 'No'}</span>
              </p>
          `: '';

          const printContent = `
        <div class="page-container">
          <div class="sticker-container">
            <div class="logo-container">
              <img src="${this.facility_logo}" alt="Hospital Logo" class="logo">
            </div>
            <h1 class="compatibility-title"><u>Compatibility Sticker</u></h1>
            <div class="compatibility-container">
              <div class="patient-info">
                <h3>Patient Details</h3>
                <p><span class="label">Patient Name:</span> <span class="value">${patient.first_name} ${patient.last_name}</span></p>
                <p><span class="label">IP/OP No:</span> <span class="value">${patient.ipop}</span></p>
                <p><span class="label">Ward:</span> <span class="value">${department}</span></p>
                <p><span class="label">Blood Group:</span> <span class="value">${patient.blood_group.description}</span></p>
                <p><span class="label">Dr. Name:</span> <span class="value">${consultant.first_name} ${consultant.last_name}</span></p>
              </div>
              <div class="product-info">
                <h3>Product Details</h3>
                <p><span class="label">Serial No:</span> <span class="value">${productDetails.serialNumber}</span></p>
                <p><span class="label">Product:</span> <span class="value">${productDetails.name}</span></p>
                <p><span class="label">Blood Group:</span> <span class="value">${productDetails.bloodGroup}</span></p>
                 ${notInAar} 
                <p><span class="label">Expiry Date:</span> <span class="value">${new Date(productDetails.expiryDate).toLocaleDateString()}</span></p>
              </div>
            </div>
            <div class="crossmatch-info">
              <p><span class="label">Prepared by:</span> <span class="value">${sample.gxm_confirmed_by.first_name || ''} ${sample.gxm_confirmed_by.last_name || ''}</span></p>
              <p><span class="label">On:</span> <span class="value">${sample.gxm_confirmed_on ? new Date(sample.gxm_confirmed_on).toLocaleDateString() : ''}</span></p>
              ${isInAar} 
            </div>
          </div>
        </div>
      `;

          allPrintContent += printContent;
        });

        const printDocument = `
      <html>
      <head>
        <title>Print Preview</title>
        <style>
          @page {
            size: A8;
            margin: 0;
          }
          * {
            box-sizing: border-box;
            margin: 0;
            padding: 0;
          }
          body {
            font-family: Manjari, sans-serif;
            margin: 0;
            padding: 0;
            background-color: white;
          }
          .page-container {
            width: 100vw;
            height: 100vh;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .sticker-container {
            width: 500px;  /* Fixed width for the content */
            padding: 20px;
            background-color: white;
            border: 1px solid #ddd;  /* Optional: adds a light border */
            box-shadow: 0 0 10px rgba(0,0,0,0.1);  /* Optional: adds a subtle shadow */
          }
          .logo-container {
            text-align: center;
            margin-bottom: 10px;
          }
          .logo {
            height: 60px;
            margin-bottom: 5px;
          }
          .hospital-name {
            color: #cc0000;
            margin: 5px 0;
            font-size: 16px;
          }
          .compatibility-title {
            text-align: center;
            font-size: 20px;
          }
          .compatibility-container {
            display: flex;
            justify-content: space-between;
            gap: 20px;
            margin-top: 10px;
          }
          .patient-info, .product-info {
            flex: 1;
          }
          h3 {
            font-size: 18px;
            margin: 0 0 10px 0;
          }
          p {
            margin: 5px 0;
            font-size: 16px;
            line-height: 1.3;
          }
          .label {
            font-weight: normal;
          }
          .value {
            font-weight: bold;
          }
          .crossmatch-info {
            text-align: center;
            margin-top: 15px;
            font-weight: bold;
          }
          @media print {
            .page-container {
              height: 100%;
              page-break-after: always;
            }
            .sticker-container {
              border: none;
              box-shadow: none;
            }
          }
        </style>
      </head>
      <body>
        ${allPrintContent}
      </body>
      </html>
    `;

        printWindow.contentDocument.open();
        printWindow.contentDocument.write(printDocument);
        printWindow.contentDocument.close();

        printWindow.contentWindow.onload = function () {
          printWindow.contentWindow.print();
        };
      } catch (error) {
        this.error = error.message || 'Failed to fetch donation';
      }
    }
  },
};
</script>
